import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta:{ title: "Minjae Kwak" }
    },
    {
      path: '/pathlit',
      name: 'PathLit',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/PathLit/PathLit.vue'),
      meta:{ title: "PathLit" }
    },

    {
      path:'/drifter',
      name:'Drifter',
      component: () => import('./views/Drifter/Drifter.vue'),
      meta:{ title: "Drifter AR" }
    },

    {
      path:'/drifter/privacy',
      name:'DrifterPrivacy',
      component: () => import('./views/Drifter/DrifterPrivacy.vue'),
      meta:{ title: 'Drifter AR - Privacy' }
    },

    {
      path: '/chatdiary',
      name: 'Chat Diary',
      component: () => import('./views/ChatDiary/ChatDiary.vue'),
      meta:{ title: "Chat Diary"}
    },

    {
      path: '/chatdiary/privacy',
      name: 'Chat Diary Privacy',
      component: () => import('./views/ChatDiary/ChatDiaryPrivacy.vue'),
      meta:{ title: "Chat Diary - Privacy" }
    },

    {
      path: '/tutorials',
      name: 'Tutorials',
      component: () => import('./views/Tutorials/Tutorials'),
      meta:{ title: "Tutorials" }
    }
  ]
});

router.afterEach((to)=>{
  document.title = to.meta.title || "Minjae Kwak";
});

export default router;